export default function ({ env }) {
  if (!process.client) {
    return;
  }

  window.fathom && env.ENV === 'production' && window.fathom.trackPageview();
}
